import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/default-landing-header-image.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/header/PageHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JumpToSection"] */ "/vercel/path0/src/features/content-sections/ui/components/JumpToSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionComponent"] */ "/vercel/path0/src/features/content-sections/ui/SectionComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/privacy/ui/PrivacyPolicyPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/src/features/shared/layout/page/PageLayout.tsx");
